<template>
    <div class="section">
        <b-loading :active.sync="loading" :if-full-page="false"></b-loading>
        
        <div class="columns is-multiline">
            <div class="column is-one-third">
                <b-field label="Departamento" label-position="on-border">
                    <b-input
                    v-model="profile.region">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Localidad/Ciudad" label-position="on-border">
                    <b-input
                    v-model="profile.location">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Codigo postal" label-position="on-border">
                    <b-input
                    v-model="profile.zipCode">
                    </b-input>
                </b-field>
            </div>
        </div>
        
        <div class="columns is-multiline" >
            <div class="column is-one-third" >
                <b-field label="Direccion" label-position="on-border">
                    <b-input
                    v-model="profile.address">
                    </b-input>
                </b-field>
            </div>
            
            <div class="column is-one-third">
                <b-field label="Numero de puerta" label-position="on-border">
                    <b-input
                    v-model="profile.number">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Numero de apt." label-position="on-border" message="Opcional">
                    <b-input
                    v-model="profile.apNumber">
                    </b-input>
                </b-field>
            </div>
            

            
            <div class="column is-one-third">
                <b-field label="Tipo documento" label-position="on-border">
                    <b-select
                    expanded
                    v-model="profile.idType">
                        <option value="CI">Cedula de identidad</option>
                        <option value="P">Pasaporte</option>
                        <option value="O">Otro</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Numero de documento" label-position="on-border">
                    <b-input
                    v-model="profile.idNumber">
                    </b-input>
                </b-field>
            </div>
            <div class="column is-one-third">
                <b-field label="Numero de telefono" label-position="on-border">
                    <b-input
                    v-model="profile.phoneNumber">
                    </b-input>
                </b-field>
            </div>

            <div class="column is-full has-text-centered">
                <b-button
                type="is-custom"
                rounded
                :loading="btnLoading"
                @click="save">
                    <b-icon icon="save" size="is-small"></b-icon>
                    Guardar cambios
                </b-button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    props:{
        profile:{
            type:Object,
            default:new Object({})
        },
        loading:{
            type:Boolean,
            default:false
        },
        btnLoading:{
            type:Boolean,
            default:false
        }
    },
    methods:{
        save(){
            this.$emit("updated")
        }
    }
}
</script>

<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}
</style>